import BBC from '../assets/newsLogo/bbc.jpg'
import ABP from '../assets/newsLogo/abp.jpg'
import ZEE from '../assets/newsLogo/zee.jpg'
import FOX from '../assets/newsLogo/fox.jpg'
import NewsLive from '../assets/newsLogo/newslive.jpg'
import SunNews from '../assets/newsLogo/sunnews.jpg'
import OneIndia from '../assets/newsLogo/oneindia.jpg'
import NewsTak from '../assets/newsLogo/newstak.jpg'
import HwNewsEnglish from '../assets/newsLogo/hwnewsenglish.jpg'
import GeoNews from '../assets/newsLogo/geonews.jpg'
import NewsNation from '../assets/newsLogo/newsnation.jpg'
import Polimer from '../assets/newsLogo/polimer.jpg'
import GMANews from '../assets/newsLogo/gmanews.jpg'
import AirOfficial from '../assets/newsLogo/airofficial.jpg'
import IndiaNews from '../assets/newsLogo/indianews.jpg'
import News18 from '../assets/newsLogo/news18.jpg'
import SainikWelfare from '../assets/newsLogo/sainikwelfare.jpg'
import DDNews from '../assets/newsLogo/dd.jpg'
import SarkariJobNews from '../assets/newsLogo/sarkarinews.jpg'
import DLS from '../assets/newsLogo/dls.jpg'

export const newsChannelData = [
    {
        channelId:'BBCNews',
        channleName:'BBC News',
        channelLogo:BBC,
        type:[],
    },
    {
        channelId:'ABPNEWS',
        channleName:'ABP News',
        channelLogo:ABP,
        type:[]
    },
    {
        channelId:'zeenews',
        channleName:'ZEE News',
        channelLogo:ZEE,
        type:[]
    },
    {
        channelId:'FoxNews',
        channleName:'FOX News',
        channelLogo:FOX,
        type:[]
    },
    {
        channelId:'NewsLiveTVofficial',
        channleName:'News Live',
        channelLogo:NewsLive,
        type:[]
    },
    {
        channelId:'Sunnewstamil',
        channleName:'SUN News',
        channelLogo:SunNews,
        type:[]
    },
    {
        channelId:'oneindia',
        channleName:'OneIndia News',
        channelLogo:OneIndia,
        type:[]
    },
    {
        channelId:'NewsTak',
        channleName:'News Tak',
        channelLogo:NewsTak,
        type:[]
    },
    {
        channelId:'HWNewsEnglish',
        channleName:'HW News',
        channelLogo:HwNewsEnglish,
        type:[]
    },
    {
        channelId:'geonews',
        channleName:'Geo News',
        channelLogo:GeoNews,
        type:[]
    },
    {
        channelId:'NewsNationTV',
        channleName:'News Nation',
        channelLogo:NewsNation,
        type:[]
    },
    {
        channelId:'PolimerNews',
        channleName:'Polimer News',
        channelLogo:Polimer,
        type:[]
    },
    {
        channelId:'gmanews',
        channleName:'GMA Integrated',
        channelLogo:GMANews,
        type:[]
    },
    {
        channelId:'NEWSONAIROFFICIAL',
        channleName:'AIR OFFICIAL',
        channelLogo:AirOfficial,
        type:[]
    },
    {
        channelId:'indianews',
        channleName:'India News',
        channelLogo:IndiaNews,
        type:[]
    },
    {
        channelId:'news18India',
        channleName:'News18 India',
        channelLogo:News18,
        type:[]
    },
    {
        channelId:'SainikWelfareNews',
        channleName:'Sainik Welfare',
        channelLogo:SainikWelfare,
        type:[]
    },
    {
        channelId:'DDnews',
        channleName:'DD News',
        channelLogo:DDNews,
        type:[]
    },
    {
        channelId:'SarkariJobNewsOfficial',
        channleName:'Sarkari Job',
        channelLogo:SarkariJobNews,
        type:[]
    },
    {
        channelId:'DLSNews',
        channleName:'DLS News',
        channelLogo:DLS,
        type:[]
    },
]